import React from 'react';
import { Link } from 'components/link';
import PhoneIcon from 'assets/svg/phone-new.svg';
import MailIcon from 'assets/svg/send.svg';
import CheckIcon from 'assets/svg/ok-check.svg';
import * as Styled from './styled';
import { useLocale } from 'locale';
import { AgentContactProps } from 'components/contact/types';
import { PoiId } from 'utils/entities';
import { createPhoneURI } from 'hooks/useDisplayPhone';
import OfficePlaceholderIcon from 'assets/svg/office-placeholder.svg';
import { Poi } from 'utils/marketplaceRoutes';
import { ContactAgentModalSource, ContactModalOpenMeta } from 'store/state/app';
import { SubmitContactAgentPayload } from 'store/state/app/payloads';
import { IContactPageSubmitVariables } from 'store/sagas/apiService/types';
import AgentPlaceholder from 'assets/svg/user-placeholder/agent.svg';
import { noop } from 'lodash';
import { Route } from 'config/routes';
import { useImageUrlBuilder } from 'hooks/useImageUrlBuilder';
import _ from 'lodash';
import { Button } from 'ds/components/button';


interface AgentInnerContactProps extends AgentContactProps {
  id: PoiId;
  onContactAgentInputClick: (eventName: string, poi: Poi) => void;
  onSetContactModalPoiId: (id: PoiId, meta: ContactModalOpenMeta) => void;
  onContactPageSubmit: (payload: SubmitContactAgentPayload) => void;
  handleSubmitEvent?: (hasErrors: boolean, formValues: IContactPageSubmitVariables, source?: string) => void;
  onCallClickEvent?: (isVisible: boolean, formValues: IContactPageSubmitVariables, source?: string) => void;
}

export const AgentInnerContact: React.FC<AgentInnerContactProps> = (props) => {
  const {
    id,
    poiType,
    officeId,
    agentId,
    isLeadingAgent,
    officeLogo,
    agentLogo,
    contactValues,
    agentName,
    officeName,
    hideAgentInfo,
    showOnlyOffice,
    isExclusive,
    phone,
    isContacted,
    onCallClickEvent = noop,
    onSetContactModalPoiId,
  } = props;

  const { t } = useLocale();
  const constructImageURI = useImageUrlBuilder();

  const handlePhoneSubmit = (e: React.MouseEvent<HTMLElement>) => {
    onCallClickEvent(false, { phone: contactValues.phone, isMortgageConsult: false, id, type: poiType }, ContactAgentModalSource.ContactSection);
  };

  const handleModalOpen = () => {
    onSetContactModalPoiId(id, { source: ContactAgentModalSource.ContactSection });
  };

  return (
    <Styled.Root>
      <Styled.FormTitle weight="bold">{t('contactForm.contact.form.withMortgage.mobile.title', { isContacted: false })}</Styled.FormTitle>
      <Styled.InfoBox>
        <Styled.LogoWrapper>
          <Link routeName={Route.OfficePage} routeParams={{ id: officeId, source: 'listing_page' }}>
            {officeLogo ? <Styled.OfficeLogo imageURL={constructImageURI(officeLogo)} /> : <OfficePlaceholderIcon width={56} height={56} />}
          </Link>
          <Link className="agent-logo" routeName={Route.AgentPage} routeParams={{ id: agentId, source: 'listing_page' }}>
            {agentLogo ? <Styled.AgentLogo imageURL={constructImageURI(agentLogo)} /> : <AgentPlaceholder width={56} height={56} />}
            {isLeadingAgent ? <Styled.LeadingLabel small weight="bold" >{t('leading.agent.contact.form.label')}</Styled.LeadingLabel> : null}
          </Link>
        </Styled.LogoWrapper>
        <Styled.TextWrapper>
          <Link routeName={showOnlyOffice ? Route.OfficePage : Route.AgentPage} routeParams={{ id: showOnlyOffice ? officeId : agentId, source: 'listing_page' }}>
            <Styled.AgentName weight="bold"  data-auto="poc-name">
              {showOnlyOffice ? officeName : agentName}
            </Styled.AgentName>
          </Link>
          {hideAgentInfo ? null : (
            <div>
              <Styled.AgentText>{t('unitPage.contactAgentHebrewExclusive', { exclusive: isExclusive })}</Styled.AgentText>
            </div>
          )}
        </Styled.TextWrapper>
      </Styled.InfoBox>

      <Styled.FormBody>
        <Styled.PhoneButton
          data-auto="phone-number-button"
          size="extraLarge"
          weight="medium"
          onClick={handlePhoneSubmit}
          href={createPhoneURI(phone)}
        >
          <PhoneIcon />
          {t('contactAgentModal.button.private.inner')}
        </Styled.PhoneButton>

        {isContacted ? (
          <Button isInitialIconColor disabled data-auto="phone-private-inner-number-button-modal-disabled" size="extraLarge" mode="ghost">
            <CheckIcon width={24} height={24} />
            {t('contactAgentModal.button.disabled.modeB.static')}
          </Button>
        ) : (
          <Button isInitialIconColor onClick={handleModalOpen} data-auto="phone-private-inner-number-button-modal" size="extraLarge" mode="ghost">
            <MailIcon width={24} height={24} />
            {t('developerPage.contactButton', { submitted: false, isMobile: false })}
          </Button>
        )}
      </Styled.FormBody>
    </Styled.Root>
  );
};
